import React from 'react';
export const Testimonial = () => {
  return <section data-name="Testimonial" data-nav-theme="light" style={{
    backgroundColor: '#FCFAF6',
    paddingTop: '80px'
  }}>

      {/* ── Constrained content ───────────────────────────────── */}
      <div className="section-content" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      paddingLeft: '24px',
      paddingRight: '24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
        {/* Logo */}
        <img src="https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/pratapsons-logo-3xan6teuexc.png" alt="Pratap Sons" data-name="Client Logo" style={{
        maxHeight: '40px',
        width: 'auto',
        display: 'block'
      }} />

        {/* Quote */}
        <p data-name="Testimonial Quote" className="testimonial-quote" style={{
        marginTop: '48px',
        marginBottom: 0,
        fontSize: '44px',
        lineHeight: 1.3,
        color: '#091717',
        textAlign: 'center',
        maxWidth: '1000px',
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 400
      }}>
          <span>“We have over 2,000 products — many were hidden before. Now they're </span>
          <span className="font-serif" style={{
          fontStyle: 'italic'
        }}>easily discoverable</span>
          <span>, the experience is </span>
          <span className="font-serif" style={{
          fontStyle: 'italic'
        }}>lightning-fast</span>
          <span>, and our conversion rates have </span>
          <span className="font-serif" style={{
          fontStyle: 'italic'
        }}>increased significantly.</span>
          <span>”</span>
        </p>

        {/* Attribution */}
        <p data-name="Testimonial Attribution" style={{
        marginTop: '24px',
        marginBottom: 0,
        fontSize: '16px',
        color: 'rgba(9, 23, 23, 0.6)',
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 500
      }}>
          — Pratap Sons
        </p>

        {/* CTA button */}
        <a href="/book-a-demo" data-name="Get a Demo Button" style={{
        display: 'inline-block',
        marginTop: '40px',
        backgroundColor: '#091717',
        color: '#FCFAF6',
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 400,
        fontSize: '16px',
        borderRadius: '999px',
        padding: '12px 24px',
        textDecoration: 'none',
        transition: 'opacity 0.2s ease'
      }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="btn-c2463091be09a5ef">
          Get a store like this
        </a>
      </div>

      {/* ── Full-width bottom divider ──────────────────────────── */}
      <div data-name="Section Divider" style={{
      marginTop: '80px',
      height: '1px',
      backgroundColor: 'rgba(9, 23, 23, 0.12)',
      width: '100%'
    }} />

    </section>;
};